import className from 'classnames/bind';
import style from '../style/Login.module.scss';
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {App as AntdApp} from "antd";
import {AuthLoginForm} from "~/features/Auth/components";
import {authErrorSelector} from "~/reduxs/Auth/authSlice";
import {globalNavigate} from "~/routes/GlobalHistory";
import {FontAwesomeIcon} from "~/components";

const cn = className.bind(style);

const FEATURES = [
    {icon: 'fa-light fa-magnifying-glass-chart', text: 'Chấm điểm SEO toàn diện theo 6 nhóm tiêu chí'},
    {icon: 'fa-light fa-ranking-star', text: 'Theo dõi thứ hạng & sức khoẻ website'},
    {icon: 'fa-light fa-shield-halved', text: 'Phân quyền linh hoạt cho từng thành viên'},
];

function Login() {

    const {notification} = AntdApp.useApp();

    const error = useSelector(authErrorSelector);

    const isLoggedIn = Boolean(localStorage.getItem('access_token'));

    useEffect(() => {
        if (error) {
            notification.error({
                title: 'Thất bại',
                description: error
            });
        }
    }, [error, notification]);

    useEffect(() => {
        if (isLoggedIn) {
            globalNavigate(process.env.REACT_APP_HOMEPAGE+"/");
        }
    }, [isLoggedIn]);

    return (
        <div className={cn('login-container')}>
            <div className={cn('login-connect')}>
                <div className={cn('mask')}></div>

                {/* decorative orbs */}
                <span className={cn('orb', 'orb-1')}></span>
                <span className={cn('orb', 'orb-2')}></span>
                <div className={cn('grid-overlay')}></div>

                <div className={cn('brand')}>
                    <span className={cn('brand-badge')}><FontAwesomeIcon icon="fa-light fa-chart-line"/></span>
                    <span className={cn('brand-name')}>Omni SEO</span>
                </div>

                <div className={cn('content')}>
                    <h2>Tối ưu thứ hạng,<br/>quản trị tập trung.</h2>
                    <p>Nền tảng phân tích & chấm điểm SEO giúp bạn nắm trọn sức khoẻ website trong một màn hình.</p>

                    <div className={cn('features')}>
                        {FEATURES.map((f, i) => (
                            <div className={cn('feature')} key={i}>
                                <span className={cn('feature-icon')}><FontAwesomeIcon icon={f.icon}/></span>
                                <span>{f.text}</span>
                            </div>
                        ))}
                    </div>

                    {/* decorative score widget */}
                    <div className={cn('score-card')}>
                        <div className={cn('score-ring')}>
                            <span className={cn('score-value')}>92</span>
                            <span className={cn('score-label')}>SEO Score</span>
                        </div>
                        <div className={cn('score-bars')}>
                            <span style={{'--h': '60%'}}></span>
                            <span style={{'--h': '85%'}}></span>
                            <span style={{'--h': '45%'}}></span>
                            <span style={{'--h': '95%'}}></span>
                            <span style={{'--h': '70%'}}></span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={cn('login-form')}>
                <div className={cn('login-form-wrapper')}>
                    <div className={cn('login-logo')}>
                        <span className={cn('login-logo-badge')}><FontAwesomeIcon icon="fa-light fa-chart-line"/></span>
                        <span className={cn('login-logo-name')}>Omni SEO</span>
                    </div>
                    <div className={cn('login-heading')}>
                        <h1>Chào mừng trở lại 👋</h1>
                        <p>Đăng nhập để tiếp tục quản trị website của bạn.</p>
                    </div>
                    <div className={cn('login-form-inner')}>
                        <AuthLoginForm/>
                    </div>
                    <div className="text-center text-sm">
                        Chưa có tài khoản? <a className="color-theme" href={process.env.REACT_APP_HOMEPAGE+"/register"}>Đăng ký ngay</a>
                    </div>
                    <div className={cn('login-footer')}>
                        © {new Date().getFullYear()} Omni SEO. Bảo lưu mọi quyền.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;
